//#region IMPORTS
import React, { useState } from 'react';
import logo from '../Assets/images/logo_short.png';
import PropTypes from 'prop-types';
import { useGetImage } from '../../../../ui/src/components/StudyListDrawer/UseGetImage';
// CSS
import './Card.css';
//#endregion

// #region COMPONENT
/**
 * @function Card
 * @returns A Card component
 */
const Card = props => {
  const {
    image,
    index,
    error,
    isLoading = false,
    description,
    doShowLogo = true,
    libelle,
    onClick,
    cardClassName,
    hoverBoxShadowColor = '#ffbc42',
    doShowRoundedCorners = true,
    imageClassName,
    imageContainerClassName,
  } = props;

  const { image: cachedImage } = useGetImage({ url: image });
  const [isHovered, setIsHovered] = useState(false);
  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`AppCard-Container ${cardClassName}`}
      style={{
        boxShadow: isHovered
          ? `0 2px 4px ${hoverBoxShadowColor}`
          : '0 2px 4px rgb(0, 0, 0)',
        animationDelay: `${(index || 0) * 0.1}s`,
      }}
      onClick={onClick}
    >
      {libelle && (
        <div className="AppCard-HeaderContainer">
          {doShowLogo && (
            <img alt="AZmed logo" src={logo} className="AppCard-HeaderLogo" />
          )}
          <div className="AppCard-Libelle">{libelle}</div>
        </div>
      )}
      {error ? (
        <div className="AppCard-Error">Error loading image</div>
      ) : isLoading ? (
        <div className="AppCard-Loading">
          <div className="AppCard-Spinner"></div>
        </div>
      ) : (
        <div className={`AppCard-ImageContainer ${imageContainerClassName}`}>
          <img
            src={cachedImage || image}
            alt={libelle}
            width="auto"
            height={'100%'}
            className={`${
              doShowRoundedCorners ? 'AppCard-Image' : ''
            } AppCard-ImageZoomIn ${imageClassName}`}
          />
        </div>
      )}
      <div className="AppCard-Description">{description}</div>
    </div>
  );
};
// #endregion

// #region PROPERTIES
/**
 * @param {string} image The card image URL
 * @param {string} description The card description
 * @param {string} libelle The card title
 * @param {function} onClick The onClick function
 * @param {string} hoverBoxShadowColor The box shadow color on hover
 * @param {bool} doShowLogo Whether to show the logo in the header
 */
Card.propTypes = {
  image: PropTypes.string,
  index: PropTypes.number,
  cardClassName: PropTypes.string,
  description: PropTypes.node.isRequired,
  libelle: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  hoverBoxShadowColor: PropTypes.string,
  doShowLogo: PropTypes.bool,
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  doShowRoundedCorners: PropTypes.bool,
  imageClassName: PropTypes.string,
  imageContainerClassName: PropTypes.string,
};
// #endregion

export { Card };
